import React, { memo, useCallback } from 'react';
import GaugeChart from '@components/gaugeChart';
import { Form } from 'antd';
import RichEditor from '@modules/questionnaires/complexity/richEditor';
import { withRouter } from 'react-router-dom';

function isEmpty(value) {
  return (
    value === undefined ||
    value === null ||
    (Array.isArray(value) && value.length === 0)
  );
}

function isSummaryEmpty(summary = {}) {
  return (
    isEmpty(summary) ||
    summary?.blocks?.length === 0 ||
    (summary?.blocks?.length === 1 && summary?.blocks[0]?.text === '')
  );
}

export const SECTION_LEVEL_PREFIX = 'section-level-';
export const SECTION_SUMMARY_PREFIX = 'section-summary-';

const getSummaryData = (summary) => {
  if (typeof summary === 'string') {
    try {
      JSON.parse(summary);
    } catch (e) {
      return summary;
    }
  }
  return summary;
};

function GaugeCard({
  title,
  isEditing,
  isManual,
  seqNum,
  cardData,
  onGaugeChange,
  history,
  gaugeBackground,
  onClickPlaceholder,
  gaugeEditable = true,
  editorProps = {},
}) {
  const chartFormName = `${SECTION_LEVEL_PREFIX}${seqNum}`;
  const richTextFormName = `${SECTION_SUMMARY_PREFIX}${seqNum}`;
  const { levelPercent, summary } = cardData || {};

  // the questionnaire section has no high risk item
  const showPlaceholder =
    !isEmpty(levelPercent) && isSummaryEmpty(summary) && !isEditing;
  // the correspond questionnaire section is incomplete
  const notComplete = isEmpty(levelPercent) && !isEditing;
  const notCompleteOnEditView = isEmpty(levelPercent) && isEditing;

  const goToQuestionnaire = useCallback(() => {
    // title represent the name of current section
    history.push({
      pathname: `/questionnaires/${title.toLowerCase()}`,
    });
  }, [title]);

  return (
    <div className="complexity-overall-card">
      <h3 className="complexity-overall-card-title">{title}</h3>
      <div className="complexity-overall-center-wrapper">
        <Form.Item noStyle name={chartFormName} initialValue={levelPercent}>
          <GaugeChart
            size="small"
            isEditing={isEditing && !notCompleteOnEditView && gaugeEditable}
            onChange={onGaugeChange}
            background={gaugeBackground}
          />
        </Form.Item>
      </div>
      {showPlaceholder || notComplete || notCompleteOnEditView ? (
        <div className="complexity-overall-card-text">
          {showPlaceholder && (
            // <div className="complexity-overall-card-placeholder">
            //   No major areas of complexity / risks identified from the
            //   questionnaire. If applicable, please fill in other complexity
            //   considerations or other insights here.
            // </div>
            <div className="complexity-overall-card-placeholder">
              <a onClick={onClickPlaceholder} className="role-control">
                Enter key opportunities and risks here
              </a>
            </div>
          )}
          {notComplete && (
            <div className="complexity-overall-card-link on-project-home role-control">
              <a onClick={goToQuestionnaire}>
                Jump to <span>{title}</span> section to complete the
                questionnaire
              </a>
            </div>
          )}
          {notCompleteOnEditView && (
            <div className="complexity-overall-card-in-process">
              {title} is not completed
            </div>
          )}
        </div>
      ) : (
        <Form.Item
          name={richTextFormName}
          className={`complexity-overall-card-editor ${
            isEditing ? 'is-editing' : ''
          }`}
          initialValue={getSummaryData(summary)}
        >
          <RichEditor
            readOnly={!isEditing}
            // className="complexity-overall-card-text"
            {...editorProps}
          />
        </Form.Item>
      )}
    </div>
  );
}

export default memo(withRouter(GaugeCard));
